module.exports = __webpack_public_path__ + "static/img/small-car.7191a68c.png";